export default async function (method, params = {}) {
    const url = `${rozetka_learnpress_global.restApi.url}${method}`
    const queryString = new URLSearchParams(params).toString()
    const fullUrl = queryString ? `${url}?${queryString}` : url

    try {
        const response = await fetch(fullUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': rozetka_learnpress_global.restApi.nonce
            },
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`)
        }

        return await response.json()
    } catch (error) {
        console.error("Fetch error: ", error)
        throw error
    }
}